/*
 Calculators Scripts File
 Author: WebCrate

 This file should contain any js scripts that are related to the
 calculators on the site, such as the cake size calculator.
 */
jQuery(function($) {

	const GANACHE_TABLE = {
		round: {
			4: {
				dark: {
					choc: 143,
					cream: 71
				},
				milk: {
					choc: 153,
					cream: 61
				},
				white: {
					choc: 160,
					cream: 54
				}
			},
			5: {
				dark: {
					choc: 187,
					cream: 94
				},
				milk: {
					choc: 201,
					cream: 80
				},
				white: {
					choc: 211,
					cream: 70
				}
			},
			6: {
				dark: {
					choc: 236,
					cream: 118
				},
				milk: {
					choc: 253,
					cream: 101
				},
				white: {
					choc: 266,
					cream: 88
				}
			},
			7: {
				dark: {
					choc: 287,
					cream: 144
				},
				milk: {
					choc: 308,
					cream: 123
				},
				white: {
					choc: 323,
					cream: 108
				}
			},
			8: {
				dark: {
					choc: 343,
					cream: 171
				},
				milk: {
					choc: 367,
					cream: 147
				},
				white: {
					choc: 385,
					cream: 129
				}
			},
			9: {
				dark: {
					choc: 402,
					cream: 201
				},
				milk: {
					choc: 431,
					cream: 172
				},
				white: {
					choc: 452,
					cream: 151
				}
			},
			10: {
				dark: {
					choc: 464,
					cream: 232
				},
				milk: {
					choc: 497,
					cream: 199
				},
				white: {
					choc: 522,
					cream: 174
				}
			},
			11: {
				dark: {
					choc: 531,
					cream: 265
				},
				milk: {
					choc: 569,
					cream: 227
				},
				white: {
					choc: 597,
					cream: 199
				}
			},
			12: {
				dark: {
					choc: 600,
					cream: 300
				},
				milk: {
					choc: 643,
					cream: 257
				},
				white: {
					choc: 675,
					cream: 225
				}
			},
			13: {
				dark: {
					choc: 673,
					cream: 337
				},
				milk: {
					choc: 721,
					cream: 289
				},
				white: {
					choc: 758,
					cream: 252
				}
			},
			14: {
				dark: {
					choc: 750,
					cream: 375
				},
				milk: {
					choc: 804,
					cream: 321
				},
				white: {
					choc: 844,
					cream: 281
				}
			},
			15: {
				dark: {
					choc: 827,
					cream: 413
				},
				milk: {
					choc: 887,
					cream: 353
				},
				white: {
					choc: 930,
					cream: 310
				}
			},
			16: {
				dark: {
					choc: 904,
					cream: 451
				},
				milk: {
					choc: 970,
					cream: 385
				},
				white: {
					choc: 1016,
					cream: 339
				}
			}
		},
		square: {
			4: {
				dark: {
					choc: 182,
					cream: 91
				},
				milk: {
					choc: 195,
					cream: 78
				},
				white: {
					choc: 205,
					cream: 68
				}
			},
			5: {
				dark: {
					choc: 239,
					cream: 119
				},
				milk: {
					choc: 256,
					cream: 102
				},
				white: {
					choc: 268,
					cream: 90
				}
			},
			6: {
				dark: {
					choc: 300,
					cream: 150
				},
				milk: {
					choc: 321,
					cream: 129
				},
				white: {
					choc: 337,
					cream: 113
				}
			},
			7: {
				dark: {
					choc: 366,
					cream: 183
				},
				milk: {
					choc: 392,
					cream: 157
				},
				white: {
					choc: 412,
					cream: 137
				}
			},
			8: {
				dark: {
					choc: 437,
					cream: 218
				},
				milk: {
					choc: 468,
					cream: 187
				},
				white: {
					choc: 491,
					cream: 164
				}
			},
			9: {
				dark: {
					choc: 511,
					cream: 256
				},
				milk: {
					choc: 548,
					cream: 219
				},
				white: {
					choc: 575,
					cream: 192
				}
			},
			10: {
				dark: {
					choc: 591,
					cream: 296
				},
				milk: {
					choc: 634,
					cream: 253
				},
				white: {
					choc: 665,
					cream: 222
				}
			},
			11: {
				dark: {
					choc: 675,
					cream: 338
				},
				milk: {
					choc: 724,
					cream: 289
				},
				white: {
					choc: 760,
					cream: 253
				}
			},
			12: {
				dark: {
					choc: 764,
					cream: 382
				},
				milk: {
					choc: 819,
					cream: 327
				},
				white: {
					choc: 860,
					cream: 286
				}
			},
			13: {
				dark: {
					choc: 857,
					cream: 429
				},
				milk: {
					choc: 919,
					cream: 367
				},
				white: {
					choc: 965,
					cream: 321
				}
			},
			14: {
				dark: {
					choc: 956,
					cream: 477
				},
				milk: {
					choc: 1023,
					cream: 409
				},
				white: {
					choc: 1074,
					cream: 358
				}
			},
			15: {
				dark: {
					choc: 1055,
					cream: 525
				},
				milk: {
					choc: 1127,
					cream: 451
				},
				white: {
					choc: 1183,
					cream: 422
				}
			},
			16: {
				dark: {
					choc: 1154,
					cream: 573
				},
				milk: {
					choc: 1231,
					cream: 493
				},
				white: {
					choc: 1292,
					cream: 459
				}
			}
		}
	};

	const SUGARPASTE_TABLE = {
		round: {
			4: {
				3: 475,
				4: 675,
				5: 900,
				6: 1100,
				3.5: 575,
				4.5: 788,
				5.5: 1000
			},
			5: {
				3: 550,
				4: 775,
				5: 1000,
				6: 1200,
				3.5: 663,
				4.5: 888,
				5.5: 1100
			},
			6: {
				3: 625,
				4: 850,
				5: 1075,
				6: 1300,
				3.5: 738,
				4.5: 963,
				5.5: 1188
			},
			7: {
				3: 725,
				4: 950,
				5: 1200,
				6: 1425,
				3.5: 838,
				4.5: 1075,
				5.5: 1313
			},
			8: {
				3: 800,
				4: 1050,
				5: 1300,
				6: 1550,
				3.5: 925,
				4.5: 1175,
				5.5: 1425
			},
			9: {
				3: 925,
				4: 1175,
				5: 1425,
				6: 1675,
				3.5: 1050,
				4.5: 1300,
				5.5: 1550
			},
			10: {
				3: 1100,
				4: 1325,
				5: 1575,
				6: 1800,
				3.5: 1213,
				4.5: 1450,
				5.5: 1688
			},
			11: {
				3: 1200,
				4: 1550,
				5: 1700,
				6: 1950,
				3.5: 1375,
				4.5: 1625,
				5.5: 1825
			},
			12: {
				3: 1300,
				4: 1550,
				5: 1825,
				6: 2075,
				3.5: 1425,
				4.5: 1688,
				5.5: 1950
			},
			13: {
				3: 1425,
				4: 1700,
				5: 1950,
				6: 2225,
				3.5: 1563,
				4.5: 1825,
				5.5: 2088
			},
			14: {
				3: 1550,
				4: 1825,
				5: 2100,
				6: 2375,
				3.5: 1688,
				4.5: 1963,
				5.5: 2238
			},
			15: {
				3: 1675,
				4: 1950,
				5: 2250,
				6: 2525,
				3.5: 1813,
				4.5: 2100,
				5.5: 2388
			},
			16: {
				3: 1800,
				4: 2100,
				5: 2425,
				6: 2725,
				3.5: 1950,
				4.5: 2263,
				5.5: 2575
			}
		},
		square: {
			4: {
				3: 600,
				4: 850,
				5: 1125,
				6: 1375,
				3.5: 725,
				4.5: 988,
				5.5: 1250
			},
			5: {
				3: 700,
				4: 975,
				5: 1250,
				6: 1525,
				3.5: 838,
				4.5: 1113,
				5.5: 1388
			},
			6: {
				3: 800,
				4: 1100,
				5: 1375,
				6: 1675,
				3.5: 950,
				4.5: 1238,
				5.5: 1525
			},
			7: {
				3: 900,
				4: 1200,
				5: 1500,
				6: 1800,
				3.5: 1050,
				4.5: 1350,
				5.5: 1650
			},
			8: {
				3: 1025,
				4: 1350,
				5: 1650,
				6: 1975,
				3.5: 1188,
				4.5: 1500,
				5.5: 1813
			},
			9: {
				3: 1250,
				4: 1550,
				5: 1825,
				6: 2125,
				3.5: 1400,
				4.5: 1688,
				5.5: 1975
			},
			10: {
				3: 1375,
				4: 1675,
				5: 2000,
				6: 2300,
				3.5: 1525,
				4.5: 1838,
				5.5: 2150
			},
			11: {
				3: 1525,
				4: 1850,
				5: 2150,
				6: 2475,
				3.5: 1688,
				4.5: 2000,
				5.5: 2313
			},
			12: {
				3: 1650,
				4: 1975,
				5: 2325,
				6: 2650,
				3.5: 1813,
				4.5: 2150,
				5.5: 2488
			},
			13: {
				3: 1800,
				4: 2150,
				5: 2475,
				6: 2825,
				3.5: 1975,
				4.5: 2313,
				5.5: 2650
			},
			14: {
				3: 1975,
				4: 2325,
				5: 2675,
				6: 3025,
				3.5: 2150,
				4.5: 2500,
				5.5: 2850
			},
			15: {
				3: 2125,
				4: 2500,
				5: 2850,
				6: 3225,
				3.5: 2313,
				4.5: 2675,
				5.5: 3038
			},
			16: {
				3: 2275,
				4: 2600,
				5: 2925,
				6: 3250,
				3.5: 2438,
				4.5: 2763,
				5.5: 3088
			}
		}
	};

	const BUTTERCREAM_TABLE = {
		round: {
			0: {
				0: {
					4: 57,
					5: 89,
					6: 128,
					7: 174,
					8: 228,
					9: 288,
					10: 356,
					11: 431,
					12: 512,
					13: 601,
					14: 697
				},
			},
			3: {
				1: {
					4: 285,
					5: 391,
					6: 512,
					7: 648,
					8: 797,
					9: 961,
					10: 1139,
					11: 1331,
					12: 1537,
					13: 1758,
					14: 1993
				},
				2: {
					4: 342,
					5: 480,
					6: 640,
					7: 822,
					8: 1025,
					9: 1249,
					10: 1494,
					11: 1761,
					12: 2050,
					13: 2359,
					14: 2690
				}
			},
			4: {
				2: {
					4: 399,
					5: 552,
					6: 726,
					7: 922,
					8: 1139,
					9: 1377,
					10: 1637,
					11: 1918,
					12: 2220,
					13: 2544,
					14: 2889
				},
				3: {
					4: 455,
					5: 640,
					6: 854,
					7: 1096,
					8: 1366,
					9: 1665,
					10: 1993,
					11: 2348,
					12: 2733,
					13: 3146,
					14: 3587
				}
			},
			5: {
				2: {
					4: 455,
					5: 623,
					6: 811,
					7: 1021,
					8: 1253,
					9: 1505,
					10: 1779,
					11: 2074,
					12: 2391,
					13: 2729,
					14: 3089
				},
				3: {
					4: 512,
					5: 712,
					6: 939,
					7: 1196,
					8: 1480,
					9: 1793,
					10: 2135,
					11: 2505,
					12: 2904,
					13: 3331,
					14: 3786
				}
			},
			6: {
				3: {
					4: 569,
					5: 783,
					6: 1025,
					7: 1295,
					8: 1594,
					9: 1921,
					10: 2277,
					11: 2662,
					12: 3074,
					13: 3516,
					14: 3985
				},
				4: {
					4: 626,
					5: 872,
					6: 1153,
					7: 1470,
					8: 1822,
					9: 2210,
					10: 2633,
					11: 3092,
					12: 3587,
					13: 4117,
					14: 4683
				}
			},
		},
		square: {
			0: {
				0: {
					4: 72,
					5: 113,
					6: 163,
					7: 222,
					8: 290,
					9: 367,
					10: 453,
					11: 548,
					12: 652,
					13: 766,
					14: 888
				},
			},
			3: {
				1: {
					4: 362,
					5: 498,
					6: 652,
					7: 824,
					8: 1015,
					9: 1223,
					10: 1450,
					11: 1694,
					12: 1957,
					13: 2238,
					14: 2537
				},
				2: {
					4: 435,
					5: 612,
					6: 815,
					7: 1046,
					8: 1305,
					9: 1590,
					10: 1903,
					11: 2242,
					12: 2609,
					13: 3003,
					14: 3425
				}
			},
			4: {
				2: {
					4: 507,
					5: 702,
					6: 924,
					7: 1173,
					8: 1450,
					9: 1753,
					10: 2084,
					11: 2442,
					12: 2827,
					13: 3239,
					14: 3678
				},
				3: {
					4: 580,
					5: 815,
					6: 1087,
					7: 1395,
					8: 1740,
					9: 2120,
					10: 2537,
					11: 2990,
					12: 3479,
					13: 4005,
					14: 4566
				}
			},
			5: {
				2: {
					4: 580,
					5: 793,
					6: 1033,
					7: 1300,
					8: 1595,
					9: 1916,
					10: 2265,
					11: 2641,
					12: 3044,
					13: 3475,
					14: 3932
				},
				3: {
					4: 652,
					5: 906,
					6: 1196,
					7: 1522,
					8: 1884,
					9: 2283,
					10: 2718,
					11: 3189,
					12: 3696,
					13: 4240,
					14: 4820
				}
			},
			6: {
				3: {
					4: 725,
					5: 997,
					6: 1305,
					7: 1649,
					8: 2029,
					9: 2446,
					10: 2899,
					11: 3388,
					12: 3914,
					13: 4476,
					14: 5074
				},
				4: {
					4: 797,
					5: 1110,
					6: 1468,
					7: 1871,
					8: 2319,
					9: 2813,
					10: 3352,
					11: 3937,
					12: 4566,
					13: 5241,
					14: 5961
				}
			},
		},
		oblong: {
			0: {
				0: {
					8: 217,
					10: 362,
					12: 544,
					13: 530,
					14: 634
				},
			},
			3: {
				1: {
					8: 815,
					10: 1214,
					12: 1685,
					13: 1658,
					14: 1921
				},
				2: {
					8: 1033,
					10: 1576,
					12: 2229,
					13: 2188,
					14: 2555
				},
			},
			4: {
				2: {
					8: 1160,
					10: 1740,
					12: 2428,
					13: 2387,
					14: 2772
				},
				3: {
					8: 1377,
					10: 2102,
					12: 2972,
					13: 2917,
					14: 3407
				},
			},
			5: {
				2: {
					8: 1287,
					10: 1903,
					12: 2627,
					13: 2587,
					14: 2990
				},
				3: {
					8: 1504,
					10: 2265,
					12: 3171,
					13: 3117,
					14: 3624
				},
			},
			6: {
				3: {
					8: 1631,
					10: 2428,
					12: 3370,
					13: 3316,
					14: 3841
				},
				4: {
					8: 1848,
					10: 2790,
					12: 3914,
					13: 3846,
					14: 4476
				},
			},
		}
	};

	var OBLONG_AREA = {
		8: 6,
		10: 8,
		12: 10,
		13: 9,
		14: 10
	};

    // as the page loads, call these scripts
    $( document ).ready( function () {

        set_default_recipe();

        add_ingredient();

        update_fields();

		remove_ingredient();

		update_radio_button();

		if ( $( '#ganache-calc' ).length > 0 ) {
			update_ganache();
		}

		if ( $( '#sugarpaste-calc' ).length > 0 ) {
			update_sugarpaste();
		}

		if ( $( '#portion-calc' ).length > 0 ) {
			update_portion();
		}

		if ( $( '#buttercream-calc' ).length > 0 ) {
			update_buttercream();
		}
	} );

    function set_default_recipe() {
        $( 'select#default-recipe' ).on( 'change', function () {
            var recipe = $( 'select#default-recipe' ).val();

            if ( recipe == 'own-recipe' ) {
				$( '#current-size' ).removeClass( 'hidden' );
				$( '#current-ingredients' ).removeClass( 'hidden' );
				$( '#new-ingredients' ).children( '.calc-heading' ).html( 'Here´s Your New Recipe' );

				// Clear any current recipe
				$( '#cake-name' ).val( '' );
				$( 'tbody#current-ingredients-list' ).empty();
				$( 'tbody#new-ingredients-list' ).empty();

				var dl_fields_to_keep = $( 'form#download' ).children( 'fieldset#no-empty' );
				$( 'form#download' ).empty();
				$( 'form#download' ).html( dl_fields_to_keep );

				return;
            }

			var current_shape_element = $( '#current-shape' );
			current_shape_element.find( '.fields #current-shape-1' ).parent( 'a' ).addClass( 'active' );
			current_shape_element.find( '.fields #current-shape-1' ).attr( 'checked', true );
			current_shape_element.find( '.fields #current-shape-2' ).parent( 'a' ).removeClass( 'active' );
			current_shape_element.find( '.fields #current-shape-2' ).attr( 'checked', false );

			var current_diameter_element = $( '#current-diameter' );
			current_diameter_element.find( '.fields .radio' ).removeClass( 'active' );
			current_diameter_element.find( '.fields .radio #current-diameter-4' ).parent( 'a' ).addClass( 'active' );
			current_diameter_element.find( '.fields a input[type="radio"]' ).attr( 'checked', false );
			current_diameter_element.find( '.fields a input[type="radio"]#current-diameter-4' ).attr( 'checked', true );

			var current_depth_element = $( '#current-depth' );
			current_depth_element.find('.fields .radio' ).removeClass( 'active' );
			current_depth_element.find('.fields .radio #current-depth-3' ).parent( 'a' ).addClass( 'active' );
			current_depth_element.find('.fields a input[type="radio"]' ).attr( 'checked', false );
			current_depth_element.find('.fields a input[type="radio"]#current-depth-3' ).attr( 'checked', true );

			$( '#current-size' ).addClass( 'hidden' );
			$( '#current-ingredients' ).addClass( 'hidden' );
			$( '#new-ingredients' ).children( '.calc-heading' ).html( 'Ingredients' );

            var recipe_json = $.parseJSON( recipe );
            var recipe_object = $.makeArray( recipe_json );
            recipe_object = recipe_object[ 0 ];

            var measurements = [ '', 'ml', 'litre', 'fl. oz', 'pint', 'quart', 'cup', 'teaspoon', 'tablespoon', 'gram', 'kg', 'oz', 'lb' ];

            // Set the cake name
            $( '#cake-name' ).val( recipe_object.recipe_name );

            // Set the ingredients
            $.each( recipe_object.ingredients, function ( key, ingredient ) {
                var measurement_options = '';

                $.each( measurements, function ( key, measurement ) {
                    var selected = '';
                    if ( measurement == ingredient.measurement ) {
                        selected = 'selected';
                    }

                    measurement_options = measurement_options.concat( '<option ' + selected + ' value="' + measurement + '">' + measurement + '</option>' );
                } );

                if ( key == 0 ) {
                    $( 'tbody#current-ingredients-list' ).empty();
					$( 'tbody#new-ingredients-list' ).empty();

					var dl_fields_to_keep = $( 'form#download' ).children( 'fieldset#no-empty' );
					$( 'form#download' ).empty();
					$( 'form#download' ).html( dl_fields_to_keep );
                }

                $( 'tbody#current-ingredients-list' ).append(
                    '<tr>' +
                        '<td class="name"><input title="ingredient" type="text" value="' + ingredient.item + '"/></td>' +
                        '<td class="current">' +
                            '<input title="current-quantity" type="text" value="' + ingredient.quantity + '"/>' +
                            '<select title="measurement" class="measurement">' + measurement_options + '</select>' +
                        '</td>' +
                        '<td class="remove"><a href="#" class="remove-ingredient"><span class="hidden-xs">Remove</span><span class="visible-xs">x</span></a></td>' +
                    '</tr>'
                );

				$( 'tbody#new-ingredients-list' ).append(
					'<tr>' +
						'<td class="name">' + ingredient.item + '</td>' +
						'<td class="new-quantity"></td>' +
					'</tr>'
				);

				$( 'form#download' ).append(
					'<fieldset class="hidden">' +
						'<input class="dl-name" name="ingredient-name[]" type="hidden" value="' + ingredient.item + '"/>' +
						'<input class="dl-quantity" name="ingredient-quantity[]" type="hidden" value=""/>' +
					'</fieldset>'
				);
            });
        } );
    }

    function add_ingredient() {
        $( '#add-ingredient' ).on( 'click', function ( e ) {
            var measurements = [ '', 'ml', 'litre', 'fl. oz', 'pint', 'quart', 'cup', 'teaspoon', 'tablespoon', 'gram', 'kg', 'oz', 'lb' ];
            var measurement_options = '';

            $.each( measurements, function ( key, measurement ) {
                measurement_options = measurement_options.concat( '<option value="' + measurement + '">' + measurement + '</option>' );
            } );

            $( 'tbody#current-ingredients-list' ).append(
                '<tr>' +
                    '<td class="name"><input title="ingredient" type="text"/></td>' +
                    '<td class="current">' +
                        '<input title="current-quantity" type="text" class="current-quantity"/>' +
                        '<select title="measurement" class="measurement">' + measurement_options + '</select>' +
                    '</td>' +
                    '<td class="remove"><a href="#" class="remove-ingredient"><span class="hidden-xs">Remove</span><span class="visible-xs">x</span></a></td>' +
                '</tr>'
            );

			$( 'tbody#new-ingredients-list' ).append(
				'<tr>' +
					'<td class="name"></td>' +
					'<td class="new-quantity"></td>' +
				'</tr>'
			);

			$( 'form#download' ).append(
				'<fieldset class="hidden">' +
					'<input class="dl-name" name="ingredient-name[]" type="hidden" value=""/>' +
					'<input class="dl-quantity" name="ingredient-quantity[]" type="hidden" value=""/>' +
				'</fieldset>'
			);

			e.preventDefault();
        } );
    }

	function remove_ingredient() {
		$( '#cake-size-calc' ).on( 'click', 'a.remove-ingredient', function( e ) {
			var all_ingredients = $( 'select.measurement' );
			var new_ingredients = $( '.new-quantity' );
			var dl_ingredients = $( '.dl-quantity' );
			var ingredient_count = all_ingredients.length;
			var current_ingredient = $( this ).parent().parent()[0];

			for ( var i = 0; i < ingredient_count; i += 1 ) {
				if ( current_ingredient == $( all_ingredients[i] ).parent().parent()[0] ) {
					$( new_ingredients[i] ).parent().remove();
					$( dl_ingredients[i] ).parent().remove();
				}
			}

			$( this ).parent().parent().remove();

			e.preventDefault();
		});
	}

    function update_fields() {
        $( '#cake-size-calc' ).on( 'change', 'input', function () {
			var cake_name = $( '#cake-name' ).val();
			$( 'form#download .cake-name' ).val( cake_name );

			var all_ingredients = $( 'select.measurement' );
			var new_ingredients = $( '.new-quantity' );
			var dl_ingredients = $( '.dl-quantity' );
			var ingredient_count = all_ingredients.length;

			for ( var i = 0; i < ingredient_count; i += 1 ) {
				update_recipe( all_ingredients[i], new_ingredients[i], dl_ingredients[i] );
			}
        } );
        $( '#cake-size-calc' ).on( 'change', 'select', function () {
			var cake_name = $( '#cake-name' ).val();
			$( 'form#download .cake-name' ).val( cake_name );

			var all_ingredients = $( 'select.measurement' );
			var new_ingredients = $( '.new-quantity' );
			var dl_ingredients = $( '.dl-quantity' );
			var ingredient_count = all_ingredients.length;

			for ( var i = 0; i < ingredient_count; i += 1 ) {
				update_recipe( all_ingredients[i], new_ingredients[i], dl_ingredients[i] );
			}
        } );
    }

	function update_ganache() {
		// Get shape of cake
		var shape = $( '#shape input:checked' ).val();

		// Get the type of chocolate used
		var choc_type = $( '#chocolate input:checked' ).val();

		// Get diameter/width of cake
		var diameter = $( '#diameter input:checked' ).val();
		diameter = parseFloat( diameter );

		var starting_choc = GANACHE_TABLE[shape][diameter][choc_type]['choc'];
		var starting_cream = GANACHE_TABLE[shape][diameter][choc_type]['cream'];
		var starting_depth = 4;
		var starting_area = 0;

		if ( shape == 'square' ) {
			starting_area = diameter * diameter; // Surface area of the top of the cake.
			starting_area += ( starting_depth * diameter ) * 4; // Surface area of the top and sides of the cake.
		} else {
			var starting_radius = diameter / 2;
			starting_area = Math.PI * ( starting_radius * starting_radius ); // Surface area of the top of the cake.
			starting_area += ( Math.PI * diameter ) * starting_depth; // Total surface area including sides
		}

		// Get number of filled layers
		var layers = $( '#layers input:checked' ).val();
		layers = parseInt( layers, 10 );

		// Get depth of cake
		var depth = $( '#depth input:checked' ).val();
		depth = parseFloat( depth );

		var area = 0;

		// Calculate area depending on whether the shape is set to square or round
		if ( shape == 'square' ) {
			area = diameter * diameter; // Surface area of the top of the cake.
			area += area * layers; // Adding extra surface area for filled layers
			area += ( depth * diameter ) * 4; // Total surface area including sides
		} else if ( shape == 'round' ) {
			var radius = diameter / 2;
			area = Math.PI * ( radius * radius ); // Surface area of the top of the cake.
			area += area * layers; // Adding extra surface area for filled layers

			if ( layers > 0 ) {
				area += 3 * layers;
			}
			area += ( Math.PI * diameter ) * depth; // Total surface area including sides
		}

		// Calculate the diameter multiplier and use it to calculate the new quantities
		var diameter_multiplier = area / starting_area;

		var choc = starting_choc * diameter_multiplier;
		var cream = starting_cream * diameter_multiplier;

		// Calculate the amount of chocolate in grams and lbs
		var choc_g = Math.ceil( choc );
		var choc_lbs = choc_g / 453.592;
		choc_lbs = choc_lbs.toFixed( 2 );
		choc_lbs = parseFloat( choc_lbs );

		// Calculate the amount of cream in grams, lbs, mls and pints
		var cream_g = Math.ceil( cream );
		var cream_lbs = cream_g / 453.592;
		cream_lbs = cream_lbs.toFixed( 2 );
		cream_lbs = parseFloat( cream_lbs );
		var cream_ml = cream_g;
		var cream_pint = cream_ml / 568.261;
		cream_pint = cream_pint.toFixed( 1 );
		cream_pint = parseFloat( cream_pint );

		// Display new values
		$( '#choc' ).html( choc_g + 'g/' + choc_lbs + 'lbs of chocolate' );
		$( '#cream' ).html( cream_g + 'g/' + cream_lbs + 'lbs of cream,' );
		$( '#cream-alt' ).html( cream_ml + 'ml/' + cream_pint + ' pint(s).' );
	}

    function update_recipe( current_ingredient, new_ingredient, dl_ingredients ) {
		var current_qty = $( current_ingredient ).prev().val();
		current_qty = parseFloat( current_qty );

		if ( ! $.isNumeric( current_qty ) ) {
			return;
		}

		// Get current and new shape
		var current_shape = $( '#current-shape input:checked' ).val();
		var new_shape = $( '#new-shape input:checked' ).val();

		// Get current diameter and initialise current_area variable
		var current_diameter = $( '#current-diameter input:checked' ).val();
		current_diameter = parseFloat( current_diameter );
		var current_area = 0;

		// Get new diameter and initialise new_area variable
		var new_diameter = $( '#new-diameter input:checked' ).val();
		new_diameter = parseFloat( new_diameter );
		var new_area = 0;

		// Calculate current area depending on whether the current shape is set to square or round
        if ( current_shape == 'square' ) {
            current_area = current_diameter * current_diameter;
        } else if ( current_shape == 'round' ) {
            var current_radius = current_diameter / 2;
            current_area = Math.PI * ( current_radius * current_radius )
        }

		// Calculate new area depending on whether the new shape is set to square or round
        if ( new_shape == 'square' ) {
            new_area = new_diameter * new_diameter;
        } else if ( new_shape == 'round' ) {
            var new_radius = new_diameter / 2;
            new_area = Math.PI * ( new_radius * new_radius )
        }

		// Calculate the diameter multiplier and use it to calculate the new quantity
        var diameter_multiplier = new_area / current_area;
        var new_qty = current_qty * diameter_multiplier;

        var current_depth = $( '#current-depth input:checked' ).val();
        current_depth = parseFloat( current_depth );

        var new_depth = $( '#new-depth input:checked' ).val();
        new_depth = parseFloat( new_depth );

        var depth_modifier = new_depth / current_depth;
        new_qty = new_qty * depth_modifier;
        new_qty = new_qty.toFixed( 1 );
        new_qty = parseFloat( new_qty );

		var name = $( current_ingredient ).parent().siblings( '.name' ).children( 'input[type="text"]').val();
        var measurement = $( current_ingredient ).val();
		measurement = maybe_pluralise_measurement( measurement, new_qty );

		$( new_ingredient ).siblings( '.name' ).html( name );
		$( new_ingredient ).html( new_qty + ' ' + measurement );
		$( dl_ingredients ).siblings( '.dl-name' ).val( name );
		$( dl_ingredients ).val( new_qty + ' ' + measurement );
    }

    function update_radio_button() {
		$( '.radio' ).on( 'click', function ( e ) {
			$( this ).siblings().removeClass( 'active' );
			$( this ).addClass( 'active' );

			$( this ).parent().find( 'input[type="radio"]' ).attr( 'checked', false );
			$( this ).children( 'input[type="radio"]' ).attr( 'checked', true );

			if ( $( '#cake-size-calc' ).length ) {
				var all_ingredients = $( 'select.measurement' );
				var new_ingredients = $( '.new-quantity' );
				var dl_ingredients = $( '.dl-quantity' );
				var ingredient_count = all_ingredients.length;

				for ( var i = 0; i < ingredient_count; i += 1 ) {
					update_recipe( all_ingredients[i], new_ingredients[i], dl_ingredients[i] );
				}
			} else if ( $( '#ganache-calc' ).length > 0 ) {
				update_ganache();
			} else if ( $( '#sugarpaste-calc' ).length > 0 ) {
				update_sugarpaste();
			} else if ( $( '#portion-calc' ).length > 0 ) {
				update_portion();
			} else if ( $( '#buttercream-calc' ).length > 0 ) {
				update_buttercream();
			}

			e.preventDefault();
		});
	}

	function maybe_pluralise_measurement( measurement, qty ) {
		if ( qty != 1 ) {
			var measurements = [ 'litre', 'pint', 'quart', 'cup', 'teaspoon', 'tablespoon', 'gram' ];

			if ( $.inArray( measurement, measurements ) != -1 ) {
				measurement = measurement + 's';
			}
		}

		return measurement;
	}

	function update_sugarpaste() {
		var shape     = $( '#shape input:checked' ).val();
		var diameter  = $( '#diameter input:checked' ).val();
		var depth     = $( '#depth input:checked' ).val();
		var thickness = $( '#thickness input:checked' ).val();

		diameter = parseFloat( diameter );
		depth    = parseFloat( depth );
		thickness = parseFloat( thickness );

		var grams = SUGARPASTE_TABLE[shape][diameter][depth];
		grams     = ( grams / 5 ) * thickness;
		grams     = Math.ceil( grams );

		var lbs   = grams / 453.592;
		lbs       = lbs.toFixed( 1 );

		$( '#grams' ).html( grams + ' grams' );
		$( '#pounds' ).html( lbs + ' pounds' );
	}

	function update_portion() {
		var shape    = $( '#shape' ).find( 'input:checked' ).val();
		var diameter = $( '#diameter' ).find( 'input:checked' ).val();
		var portion_size  = $( '#portion-size' ).find( 'input:checked' ).val();

		diameter              = parseFloat( diameter );
		var portion_size_arr  = portion_size.split( 'x' );
		var total_area   = 0;

		if ( shape == 'square' ) {
			total_area = diameter * diameter;
		} else {
			var radius = diameter / 2;
			total_area = Math.PI *  ( radius * radius );
		}

		var portion_area = portion_size_arr[0] * portion_size_arr[1];
		var portions = total_area / portion_area;
		portions     = Math.floor( portions );

		$( '#portions' ).html( portions + ' portions (' + portion_size + ' inch)' );
	}

	function update_buttercream() {
		// Cover and fill or Fill only
		var fill = $( '#fill input:checked' ).val();
		var fill_only = (fill === 'fill-only');

		if ( fill_only ) {
			$( '#fill' ).addClass( 'fill-only-init' );
		}

		// Get shape of cake
		var shape = $( '#shape input:checked' ).val();

		// Show correct diameters
		if ( shape == 'oblong' ) {
			$( '.fields.oblong' ).removeClass( 'hidden' );
			$( '.fields.round' ).addClass( 'hidden' );

			if ( ! $( '.fields.oblong' ).hasClass( 'init' ) ) {
				$( '.fields.oblong .radio label' ).each( ( key, el ) => {
					var value = $( el ).text();

					$( el ).html( `${value} x ${OBLONG_AREA[ value ]}` );
				} );

				$( '.fields.oblong' ).addClass( 'init' );
			}
		} else {
			$( '.fields.round' ).removeClass( 'hidden' );
			$( '.fields.oblong' ).addClass( 'hidden' );
		}

		// Get diameter/width of cake
		var diameter = $( '#diameter' ).find( ` .${shape} input:checked ` ).val();
		diameter = parseFloat( diameter );

		// Get depth of cake
		var depth = $( '#depth input:checked' ).val();
		depth = parseInt( depth, 10 );

		// Get number of filled layers
		var layers = $( '#layers input:checked' ).val();
		layers = parseInt( layers, 10 );

		var layer_change = false;

		if ( ! fill_only && $( '#fill' ).hasClass( 'fill-only-init' ) ) {
			depth = 3;
			layers = 1;
			layer_change = true;

			$( '.filled-layers' ).removeClass( 'disabled' );
			$( '#fill' ).removeClass( 'fill-only-init' );
		}

		// Disable filled layers depending on depth of cake
		$( '.filled-layers' ).removeClass( 'disabled' );

		if ( ! fill_only ) {
			if ( depth === 3 ) {
				$( ' .layers-3, .layers-4 ' ).addClass( 'disabled' );

				if ( [ 3, 4 ].includes( layers ) ) {
					layers = 1;
					layer_change = true;
				}
			} else if ( depth === 4 || depth === 5 ) {
				$( ' .layers-1, .layers-4 ' ).addClass( 'disabled' );

				if ( [ 1, 4 ].includes( layers ) ) {
					layers = 2;
					layer_change = true;

				}
			} else if ( depth === 6 ) {
				$( ' .layers-1, .layers-2 ' ).addClass( 'disabled' );

				if ( [ 1, 2 ].includes( layers ) ) {
					layers = 3;
					layer_change = true;
				}
			}
		}

		if ( layer_change ) {
			$( `.layers-${layers}` ).trigger( 'click' );
		}

		var buttercream = 0;

		if ( fill_only ) {
			// Get Fill Only data
			buttercream = BUTTERCREAM_TABLE[ shape ][ 0 ][ 0 ][ diameter ];
			buttercream = buttercream * layers;

			$( '#depth' ).addClass( 'disabled' );
		} else {
			// Get Cover and Fill data
			buttercream = BUTTERCREAM_TABLE[ shape ][ depth ][ layers ][ diameter ];

			$( '#depth' ).removeClass( 'disabled' );
		}

		// Calculate the amount of cream in grams, lbs, mls and pints
		var cream_g = Math.ceil( buttercream );
		var cream_lbs = cream_g / 453.592;
		cream_lbs = cream_lbs.toFixed( 2 );
		cream_lbs = parseFloat( cream_lbs );

		// Display new values
		$( '#buttercream' ).html( cream_g + 'g/' + cream_lbs + 'lbs of buttercream.' );
	}
});